export default __webpack_public_path__ + "static/media/success.14e97bf7.png";